<template>
	<div class="c-toast">
		<transition-group name="list" tag="div">
			<ToastItem
				v-for="toast in toasts"
				:toastObject="toast"
				:key="toast.id"
				@remove="onRemove"
			>
			</ToastItem>
		</transition-group>
	</div>
</template>

<script>
import nanoid from 'nanoid';
import ToastItem from '@/components/ui/toast-item';
export default {
	components: {
		ToastItem,
	},

	data: function () {
		return {
			toasts: [],
		};
	},

	watch: {
		messageTrigger: function () {
			this.showMessage(this.message);
		},
	},

	computed: {
		messageTrigger: function () {
			return this.$store.getters['message/updateTrigger'];
		},
		message: function () {
			return this.$store.getters['message/message'];
		},
	},

	methods: {
		onRemove: function (id) {
			this.toasts = this.toasts.filter((toast) => {
				if (toast.id === id) {
					return false;
				} else {
					return true;
				}
			});
		},
		showMessage: function (info) {
			// Don't show toast if tab is not in view
			if (document.visibilityState === 'hidden') {
				return;
			}
			let type = info.type || 'default';
			let content = '';
			let title = '';
			if (typeof info.message === 'string') {
				content = info.message;
				title = '';
			} else {
				content = info.message.content;
				title = info.message.title || '';
			}
			this.toasts.push({
				id: nanoid(),
				type: type,
				title: title,
				content: content,
			});
		},
	},
	mounted: function () {},
};
</script>

<style lang="scss">
.c-toast {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: var(--z-3);
	padding: 0 var(--spacer);
	pointer-events: none;

	> div {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.list-item {
		display: inline-block;
		transition: all var(--transition-time-lg);
	}
	.list-enter,
	.list-leave-to {
		opacity: 0;
		transform: translateY(4px);
		max-height: 200px;
	}
	.list-leave-active {
		position: absolute;
	}

	// .list-move {
	// 	transition: transform var(--transition-time-lg)
	// 		cubic-bezier(0.3, 0.76, 0.57, 1.05);
	// }
}
</style>